export default {
  feedback: {},
  feedbackComment: {},
  user: {},
  reaction: {},
  reviewTemplate: {},
};
